// Auto-generated skeleton for RolePermission

import { Role } from "./Role";
import { Building } from "./Building";
import { Unit } from "./Unit";
import { Person } from "./Person";

export const RolePermission: Api.RolePermission = {
  id: 0,
  hp_id: null,
  role_id: 0,
  person_id: 0,
  building_id: 0,
  unit_id: 0,
  started_at: '',
  ended_at: null,
  created: null,
  updated: null,
  role: Role,
  building: Building,
  unit: Unit,
  person: Person,
};

